// -------------------------------------------------------------------------------
// Libraries
// -------------------------------------------------------------------------------
import React from "react";
import { Form, Switch, Typography } from "antd";

// -------------------------------------------------------------------------------
// Styles
// -------------------------------------------------------------------------------
import StyledFormInput from "./styles";

const FormCheckbox = ({
	name,
	label,
	rules,
	autoComplete,
	placeholder = "",
	maxLength = null,
	isChecked,
	tooltipTitle = "",
	style = {},
}) => {
	return (
		<StyledFormInput className="sb-form-input" style={style}>
			<Form.Item
				layout="horizontal"
				name={name}
				valuePropName="checked"
				label={<Typography.Text>{label}</Typography.Text>}
				rules={rules}
				tooltip={{ title: tooltipTitle }}
				required={false}
			>
				<Switch />
			</Form.Item>
		</StyledFormInput>
	);
};

export default FormCheckbox;

